import { render, staticRenderFns } from "./info-modal.vue?vue&type=template&id=12656b07&scoped=true"
import script from "./info-modal.vue?vue&type=script&lang=js"
export * from "./info-modal.vue?vue&type=script&lang=js"
import style0 from "./info-modal.vue?vue&type=style&index=0&id=12656b07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12656b07",
  null
  
)

export default component.exports